<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-4 col-12 mb-2">
        <h3 class="content-header-title">FAQ's</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-collapse">
                <div class="card mb-0 faqs">

                  <div class="card" v-for="faq in faqs" v-bind:key="faq.id" v-if="faq.enabled == 1">

                    <div class="card-header">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse-' + faq.id"  aria-expanded="false">
                          {{faq.title}}
                        </button>
                      </h5>
                    </div>

                    <div v-bind:id="'collapse-' + faq.id" class="collapse">
                      <div class="card-body">
                        <p>{{faq.body}}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'faq',
  data: function () {
    return {
      faqs: []
    }
  },
  mounted: function () {
    var that = this

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'basic/faqs',
      type: 'post',
      success: function (data) {
        that.faqs = data.data
      }
    })
  }
}
</script>

<style scoped>
.faqs .btn {
  white-space:normal !important;
  text-align:left;
}
</style>
